import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// import './pagetemplate.style.js';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 3.75rem;
  min-height: 100vh;
  box-sizing: border-box;
  @media screen and (max-width: 640px) {
    padding-top: 3.25rem;
  }
`;

const Header = styled.header`
  width: 100%;
  margin: 1rem auto 0 auto;
  max-width: 400px;
  box-sizing: border-box;
  text-align: center;
`;

const Content = styled.section`
  width: 100%;
  box-sizing: border-box;
  margin: 1rem auto;
  max-width: 400px;
`;

const Footer = styled.footer`
  margin-top: auto;
`;

const PageTemplate = ({
  header,
  children,
  footer,
  ...props
}) => {
  return (
    <Wrapper {...props}>
      <Header>{header}</Header>
      <Content>{children}</Content>
      <Footer>{footer}</Footer>
    </Wrapper>
  );
};

PageTemplate.propTypes = {
  header: PropTypes.node.isRequired,
  footer: PropTypes.node,
  children: PropTypes.any.isRequired,
};

export default PageTemplate;
